if (!customElements.get("m-localization-form")) {
  class MLocalizationForm extends HTMLElement {
    constructor() {
      super();
      const select = this.querySelector('[data-localization-select]');
      select && select.addEventListener('change', (e) => {
        const value = e.target.value
        const form = select.closest('[data-localization-form]')
        const input = form.querySelector('input[data-localization-input]')
        input && input.setAttribute('value', value)
        // The server writes return_to once, at page load, so it is stale after an option change. Return to the page the shopper is
        // looking at now: on the main product page the variant that is selected right now (never an old or unresolved one), and the
        // address fragment (the silver picker keeps its selection there).
        const returnTo = form.querySelector('input[name="return_to"]')
        if (returnTo) returnTo.value = MLocalizationForm.returnTarget()
        input && form.submit()
      });
      // Native picker (select + Apply): the form is submitted by the Apply button, so refresh the return target at submit time too.
      const applyForm = this.closest('[data-localization-form]') || this.querySelector('[data-localization-form]')
      applyForm && applyForm.addEventListener('submit', () => {
        const target = applyForm.querySelector('input[name="return_to"]')
        if (target) target.value = MLocalizationForm.returnTarget()
      });
    }

    static returnTarget() {
      const here = new URL(window.location.href)
      // Always a single-slash local path (never "//host" or an absolute URL).
      const path = '/' + here.pathname.replace(/^\/+/, '')
      let search = here.search
      const product = document.querySelector('product-info[id^="MainProduct"]')
      const isMainProduct = product && (!product.dataset || !product.dataset.viewMode || product.dataset.viewMode === 'main-product')
      // currentVariant is undefined until the controller has started, null while no variant is resolved, an object once it is.
      if (isMainProduct && /\/products\/[^/]+\/?$/.test(path) && product.currentVariant !== undefined) {
        const params = new URLSearchParams(here.search)
        const picked = product.currentVariant && product.currentVariant.id
        if (/^[1-9]\d*$/.test(String(picked || ''))) params.set('variant', String(picked))
        else params.delete('variant')
        const query = params.toString()
        search = query ? '?' + query : ''
      }
      return path + search + here.hash
    }
  }
  customElements.define('m-localization-form', MLocalizationForm);
}